import { Bot, Globe, PhoneCall, Send } from 'lucide-react'
import React from 'react'

interface QuickStatCardProps {
  total_messages: number;
  campaign_messages: number;
  transactional_messages: number;
  total_voice_calls: number;
}


const QuickStatCard: React.FC<QuickStatCardProps> = ({
  total_messages,
  campaign_messages,
  transactional_messages,
  total_voice_calls,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {/* Total Messages */}
      <div className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 dark:border-gray-700 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 dark:text-gray-400 mb-1">Total Messages</p>
            <p className="text-2xl font-bold text-slate-800 dark:text-gray-100">
              {total_messages?.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-blue-100 dark:bg-blue-500/15 rounded-xl">
            <Send className="w-6 h-6 text-blue-600" />
          </div>
        </div>
      </div>

      {/* Voice Calls */}
      <div className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 dark:border-gray-700 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 dark:text-gray-400 mb-1">Campaign Messages</p>
            <p className="text-2xl font-bold text-slate-800 dark:text-gray-100">
              {campaign_messages?.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-red-100 dark:bg-red-500/15 rounded-xl">
            <PhoneCall className="w-6 h-6 text-red-600" />
          </div>
        </div>
      </div>

      {/* AI Interactions */}
      <div className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 dark:border-gray-700 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 dark:text-gray-400 mb-1">Transactional Messages</p>
            <p className="text-2xl font-bold text-slate-800 dark:text-gray-100">
              {transactional_messages?.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-indigo-100 dark:bg-indigo-500/15 rounded-xl">
            <Bot className="w-6 h-6 text-indigo-600" />
          </div>
        </div>
      </div>

      {/* Countries */}
      <div className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm rounded-2xl p-6 border border-slate-200 dark:border-gray-700 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-slate-500 dark:text-gray-400 mb-1">Total Voice Calls</p>
            <p className="text-2xl font-bold text-slate-800 dark:text-gray-100">
              {total_voice_calls?.toLocaleString()}
            </p>
          </div>
          <div className="p-3 bg-green-100 dark:bg-green-500/15 rounded-xl">
            <Globe className="w-6 h-6 text-green-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickStatCard